import dayjs from 'dayjs';
import Flatpickr from 'react-flatpickr';

function ReportsPageHeader({ formData, setFormData }) {
    // const navigate = useNavigate();

    const handleChange = (e) => {
        if (e.length === 2) {
            // navigate(
            //     mkRelativeUrl('/reports/', {
            //         'start-date': dayjs(e[0]).format('YYYY-MM-DD'),
            //         'end-date': dayjs(e[1]).format('YYYY-MM-DD')
            //     })
            // );
            setFormData({
                startDate: dayjs(e[0]).format('YYYY-MM-DD'),
                endDate: dayjs(e[1]).format('YYYY-MM-DD')
            });
        }
    };
    return (
        <div className="report_page_header w-full mb-7 flex flex-row justify-between items-center">
            <div className="client_page_header_left_col flex-1 flex items-center gap-x-5">
                <div className="date_time">
                    <Flatpickr
                        options={{ mode: 'range' }}
                        value={[formData?.startDate, formData?.endDate]}
                        onChange={handleChange}
                        placeholder="Ex. 22-Aug-2020 to 22-Aug-2021"
                        className="w-[250px] h-10 pl-2 text-primary text-sm font-normal leading-6 rounded-xl border border-neutral-900 border-opacity-20 outline-none"
                    />
                </div>
            </div>
        </div>
    );
}

export default ReportsPageHeader;
